import React from 'react'
import AnnotationHeader from './AnnotationHeader'
import PubAnnotations from './PubAnnotations'

import PhotoIcon from 'src/images/icons/photo_icon.svg'

class PhotoAnnotation extends React.Component {
  constructor(props) {
    super(props)
    this.onAddPhotoClick = this.onAddPhotoClick.bind(this)
    this.onRemovePhotoClick = this.onRemovePhotoClick.bind(this)
  }

  onAddPhotoClick() {
    PubAnnotations.init().saveAddPhotoAnnotation(this.props.annotation)
  }

  onRemovePhotoClick(){
    PubAnnotations.init().saveRemoveTypeAnnotation(this.props.annotation, {type: 'Annotation::RemovePhoto'})
  }

  render() {
    return (
      <div className="card p-0">
        <AnnotationHeader
          onSelect={this.props.onSelect}
          annotation={this.props.annotation}
          roleType={this.props.roleType}
          annotationTypes={this.props.annotationTypes} />
        <div className="text-center py-5 grey-text text-darken-2 px-9">
          <img className='m-auto pb-2' src={PhotoIcon}/>
          <h1>Do you need to add or remove photos?</h1>
        </div>
        <div className="d-flex flex-row justify-content-center pb-4">
          <button className="btn-flat" onClick={this.onAddPhotoClick}>Add Photos</button>
          <button className="btn-flat" onClick={this.onRemovePhotoClick}>Remove Photos</button>
        </div>
      </div>
      )
  }
}

export default PhotoAnnotation
